import React from 'react';
import { Drawer } from 'antd';
import cn from 'classnames';
import styles from './BottomDrawer.module.scss';

const BottomDrawer = ({
  children,
  onClose,
  visible,
  bodyStyle,
  className,
  ...props
}) => {
  return (
    <Drawer
      {...props}
      className={cn(styles.root, className)}
      placement="bottom"
      onClose={onClose}
      visible={visible}
      height="auto"
      destroyOnClose
      bodyStyle={bodyStyle}
    >
      {children}
    </Drawer>
  );
};

export default BottomDrawer;
